import { createTheme } from '@mui/material/styles';

/**
 * Tema Material 3 (Google) en modo oscuro:
 *  - superficies #131314 / #1e1f20 y primario azul Google (#a8c7fa);
 *  - formas grandes (14-24 px), botones pill y tipografia Roboto;
 *  - sin mayusculas en botones (convencion M3).
 */
export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#a8c7fa', dark: '#7da7f0', light: '#d3e3fd', contrastText: '#062e6f' },
    secondary: { main: '#f2b8b5', contrastText: '#601410' },
    success: { main: '#81c995' },
    warning: { main: '#fdd663' },
    error: { main: '#f28b82' },
    info: { main: '#a8c7fa' },
    background: { default: '#131314', paper: '#1e1f20' },
    text: { primary: '#e3e3e3', secondary: '#c4c7c5' },
    divider: 'rgba(227,227,227,0.12)',
  },
  shape: { borderRadius: 16 },
  typography: {
    fontFamily: '"Roboto", "Segoe UI", system-ui, -apple-system, sans-serif',
    h4: { fontWeight: 500, letterSpacing: '-0.5px' },
    h5: { fontWeight: 500, letterSpacing: '-0.3px' },
    h6: { fontWeight: 500, letterSpacing: '-0.2px' },
    subtitle1: { fontWeight: 500 },
    subtitle2: { fontWeight: 500 },
    button: { textTransform: 'none', fontWeight: 500, letterSpacing: 0 },
    overline: { letterSpacing: '0.8px', fontWeight: 500 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          minHeight: '100dvh',
          backgroundImage:
            'radial-gradient(1100px 560px at 12% -12%, rgba(168,199,250,0.10), transparent 60%),' +
            'radial-gradient(900px 480px at 108% -6%, rgba(242,184,181,0.06), transparent 55%)',
          backgroundAttachment: 'fixed',
        },
      },
    },
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 999, paddingInline: 20, minHeight: 40 },
        containedPrimary: { '&:hover': { backgroundColor: '#d3e3fd' } },
      },
    },
    MuiIconButton: { styleOverrides: { root: { borderRadius: 999 } } },
    MuiOutlinedInput: {
      styleOverrides: { root: { borderRadius: 14, backgroundColor: 'rgba(255,255,255,0.03)' } },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 999,
          paddingInline: 16,
          borderColor: 'rgba(227,227,227,0.16)',
        },
      },
    },
    MuiChip: { styleOverrides: { root: { borderRadius: 999, fontWeight: 500 } } },
    MuiTooltip: {
      defaultProps: { arrow: true },
      styleOverrides: { tooltip: { borderRadius: 8, fontSize: 12 } },
    },
    MuiSlider: {
      styleOverrides: {
        root: { paddingBlock: 10 },
        thumb: { boxShadow: '0 0 0 4px rgba(168,199,250,0.16)' },
      },
    },
    MuiAlert: { styleOverrides: { root: { borderRadius: 14 } } },
  },
});
